import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Text } from '@common-fe/common-fe';


const FeeFooter = () => {
  const { t } = useTranslation();
  return (
    <Box>
      <Text size="medium" weight={700} margin={{bottom: 's'}}>
        {t('Fees to Invest')}
      </Text>     
      <Text size="medium" weight={400} color="textSecondary" margin={{bottom :'s'}}>
        {t('Fees to invest depend on the investment path you choose. Managed funds will be billed .04% annually and deducted from the cash portion of your investment account on a quarterly basis. Investments are not liquidated to cover investment fees. No other investment selections have annual fees. No other fees apply.')}
      </Text>
      <Text size="medium" weight={400} color="textSecondary">
        {t('In the event the cash portion of your account does not have a sufficient balance to pay your investment service fee, a negative balance will be reflected on your account until a contribution is posted to your account by your employer or a liquidation of your investment positions is initiated by you, the account holder.')}
      </Text>
    </Box>
  );
};
export default FeeFooter;